import { SURVEYS_REQUEST, SURVEYS_COMPLETE, SURVEYS_TYPES_REQUEST, SURVEYS_FETCH, SURVEYS_FETCH_LIST, SURVEYS_FETCH_TYPES,
	SURVEYS_EDIT, SURVEYS_QUESTIONS_EDIT, SURVEYS_CLEAR, SURVEYS_FAIL } from "../store/config";

const surveysInit = {
	isFetching: false,
	list: [],
	types:{
		isFetching: false,
		list:[]
	},
	pages:{
		current: undefined,
		per_page: undefined,
		total: undefined
	},
	edit: {
		children_questions:[]
	},
	permissions: [],
	error: null,
	message: null
}

const surveys = (state=surveysInit, action) => {
	switch (action.type){
		case SURVEYS_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case SURVEYS_TYPES_REQUEST:
			return {
				...state,
				types:{
					...state.types,
					isFetching: action.isFetching
				},
				timestamp: action.timestamp
			}
		case SURVEYS_FETCH:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				pages: action.pages,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case SURVEYS_FETCH_LIST:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				timestamp: action.timestamp
			}
		case SURVEYS_FETCH_TYPES:
			return {
				...state,
				types: {
					...state.types,
					isFetching: action.isFetching,
					list: action.payload
				},
				timestamp: action.timestamp
			}
		case SURVEYS_EDIT:
			return {
				...state,
				edit: {
					...state.edit,
					...action.payload
				},
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case SURVEYS_QUESTIONS_EDIT:
			return {
				...state,
				edit: {
					...state.edit,
					questions: action.payload
				},
				timestamp: action.timestamp
			}
		case SURVEYS_CLEAR:
			return {
				...state,
				edit: action.payload,
				timestamp: action.timestamp
			}
		case SURVEYS_COMPLETE:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case SURVEYS_FAIL:
			return {
				...state,
				isFetching: action.isFetching,
				error: action.isFetching,
				timestamp: action.timestamp
			}
		default:
			return{
				...state
			}
	}
}

export default surveys;


// WEBPACK FOOTER //
// ./src/reducers/surveys.js